/**
 * apiError.js
 * API 호출 실패 시 사용자에게 보여줄 메시지를 일관되게 추출하는 공용 유틸.
 *
 * 백엔드 공통 응답(CommonApiResponse)은 { resultCode, message, data } 형태이며,
 * 오류(4xx/5xx) 시에도 message에 안내 문구가 담겨 온다(§3.4, §6.12).
 * 네트워크 단절 등 응답 자체가 없는 경우엔 fallback 문구를 사용한다.
 *
 * @param {*} err - axios catch에서 받은 에러 객체
 * @param {string} fallback - 응답 메시지가 없을 때 사용할 기본 안내 문구
 * @returns {string} 사용자에게 표시할 안내 메시지
 */
export function resolveApiErrorMessage(err, fallback = '요청 처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.') {
    // CommonApiResponse는 message(소문자), 일부 미들웨어 경로는 Message(대문자)로 올 수 있어
    // 양쪽 키를 모두 확인해 응답 키 표기에 관계없이 안내 문구가 끊기지 않게 한다(§3.4).
    const data = err?.response?.data;
    const serverMessage = data?.message ?? data?.Message;
    if (typeof serverMessage === 'string' && serverMessage.trim()) {
        return serverMessage;
    }
    return fallback;
}
